import Column from '../../types/Column';
import { CompareResultType } from '../../organisms/ComparePlayersTable';

export const USER_SETTINGS_LOADING = 'user-settings/USER_SETTINGS_LOADING';
export const USER_SETTINGS_LOADED = 'user-settings/USER_SETTINGS_LOADED';
export const SET_SEARCH_COLUMNS = 'user-settings/SET_SEARCH_COLUMNS';
export const SET_SAVED_PLAYERS_COLUMNS = 'user-settings/SET_SAVED_PLAYERS_COLUMNS';
export const SET_TEAM_PLAYERS_COLUMNS = 'user-settings/SET_TEAM_PLAYERS_COLUMNS';
export const SET_COMPARE_PLAYERS_COLUMNS = 'user-settings/SET_COMPARE_PLAYERS_COLUMNS';
export const SET_MANAGE_USERS_COLUMNS = 'user-settings/SET_MANAGE_USERS_COLUMNS';
export const SET_MANAGE_PROGRAMS_COLUMNS = 'user-settings/SET_MANAGE_PROGRAMS_COLUMNS';
export const SET_COMPARE_PLAYERS_RESULT_TYPE = 'user-settings/SET_COMPARE_PLAYERS_RESULT_TYPE';
export const SET_IS_BOARD_LAST_VIEW_ON_DASHBOARD = 'user-settings/SET_IS_BOARD_LAST_VIEW_ON_DASHBOARD';
export const SET_USER_SETTING_CBTN_USERNAME = 'user-settings/SET_USER_SETTING_CBTN_USERNAME';
export const SET_COLLEGE_DASHBOARD_SELECTED_YEAR = 'user-settings/SET_COLLEGE_DASHBOARD_SELECTED_YEAR';
export const SET_NFL_DASHBOARD_SELECTED_YEAR = 'user-settings/SET_NFL_DASHBOARD_SELECTED_YEAR';
export const SET_PROFILE_STATS_CATEGORIES = 'user-settings/SET_PROFILE_STATS_CATEGORIES';
export const SET_PROFILE_STATS_CATEGORIES_NFL = 'user-settings/SET_PROFILE_STATS_CATEGORIES_NFL';
export const SET_PLAYER_EVALUATION_VALIDATION_IS_ALL = 'user-settings/SET_PLAYER_EVALUATION_VALIDATION_IS_ALL';
export const SET_PLAYER_VALIDATION_SETTING = 'user-settings/SET_PLAYER_VALIDATION_SETTING';

export function setUserSettingsLoadingAction (userSettingsLoading:boolean) {
  return {
    type: USER_SETTINGS_LOADING,
    userSettingsLoading,
  };
}

export function setUserSettingsLoadedAction (userSettingsLoaded:boolean) {
  return {
    type: USER_SETTINGS_LOADED,
    userSettingsLoaded,
  };
}

export function setSearchColumnsAction (searchColumns:Column[] | null) {
  return {
    type: SET_SEARCH_COLUMNS,
    searchColumns,
  };
}

export function setSavedPlayersColumnsAction (savedPlayersColumns:Column[] | null) {
  return {
    type: SET_SAVED_PLAYERS_COLUMNS,
    savedPlayersColumns,
  };
}

export function setTeamPlayersColumnsAction (teamPlayersColumns:Column[] | null) {
  return {
    type: SET_TEAM_PLAYERS_COLUMNS,
    teamPlayersColumns,
  };
}

export function setComparePlayersColumnsAction (comparePlayersColumns:Column[] | null) {
  return {
    type: SET_COMPARE_PLAYERS_COLUMNS,
    comparePlayersColumns,
  };
}

export function setComparePlayersResultTypeAction (comparePlayersResultType:CompareResultType | null) {
  return {
    type: SET_COMPARE_PLAYERS_RESULT_TYPE,
    comparePlayersResultType,
  };
}

export function setManageUsersColumnsAction (manageUsersColumns:Column[] | null) {
  return {
    type: SET_MANAGE_USERS_COLUMNS,
    manageUsersColumns,
  };
}

export function setManageProgramsColumnsAction (manageProgramsColumns:Column[] | null) {
  return {
    type: SET_MANAGE_PROGRAMS_COLUMNS,
    manageProgramsColumns,
  };
}

export function setIsBoardLastViewOnDashboardAction (isBoardLastViewOnDashboard:boolean) {
  return {
    type: SET_IS_BOARD_LAST_VIEW_ON_DASHBOARD,
    isBoardLastViewOnDashboard,
  };
}

export function setUserSettingCtbnUsername (userSettingCtbnUsername: string | null) {
  return {
    type: SET_USER_SETTING_CBTN_USERNAME,
    userSettingCtbnUsername,
  };
}
export function setCollegeDashboardSelectedYearAction (collegeDashboardSelectedYear:number | null) {
  return {
    type: SET_COLLEGE_DASHBOARD_SELECTED_YEAR,
    collegeDashboardSelectedYear,
  }
}

export function setNflDashboardSelectedYearAction (nflDashboardSelectedYear:number | null) {
  return {
    type: SET_NFL_DASHBOARD_SELECTED_YEAR,
    nflDashboardSelectedYear,
  }
}

export function setProfileStatsCategoriesAction (profileStatsCategories:string[] | null) {
  return {
    type: SET_PROFILE_STATS_CATEGORIES,
    profileStatsCategories,
  };
}

export function setProfileStatsCategoriesNFLAction (profileStatsCategoriesNFL:string[] | null) {
  return {
    type: SET_PROFILE_STATS_CATEGORIES_NFL,
    profileStatsCategoriesNFL,
  };
}

export function setPlayerEvaluationValidationIsAllAction (playerEvaluationValidationIsAll:boolean) {
  return {
    type: SET_PLAYER_EVALUATION_VALIDATION_IS_ALL,
    playerEvaluationValidationIsAll,
  };
}

export function setPlayerValidationSettingAction (playerId:number, isChecked:boolean) {
  return {
    type: SET_PLAYER_VALIDATION_SETTING,
    playerId,
    isChecked,
  };
}
